import React from "react";

export default class Minutes extends React.Component {
  render() {
    return <div>This is minute view</div>;
  }
}
